import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconDocSpreadsheet(props: SvgIconProps) {
  return (
    <SVGIcon width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M0 1L10 0.999999L10 0.499999C10 0.223857 9.77614 -8.54658e-07 9.5 -8.30516e-07L0.5 -4.37114e-08C0.223858 -1.95703e-08 -6.78525e-08 0.223858 -4.37114e-08 0.5L0 1Z"
        fill="currentColor"
      />
      <path
        d="M-4.37114e-08 11.5C-1.95703e-08 11.7761 0.223858 12 0.5 12L2 12L2 2L-8.74228e-07 2L-4.37114e-08 11.5Z"
        fill="currentColor"
      />
      <path d="M3 12L9.5 12C9.77614 12 10 11.7761 10 11.5L10 2L3 2L3 12Z" fill="currentColor" />
    </SVGIcon>
  );
}
